export default "__VITE_ASSET__DskwVQEP__"